import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { FavoriteViewObject } from '@/types/apiServerContract';

class FavoriteListCrudOverlayService extends AbstractModalService {
    public show(details: FavoriteViewObject | null, canDelete: boolean, mode: 'edit' | 'create') {
        return this.showModal({
            component: () => import(
                /* webpackChunkName: 'myaccount' */
                '@/project/app/client-pages/my-account/favourites/FavouritesCrudListOverlay.vue'),
            componentAttrs: {
                details,
                canDelete,
                mode
            },
            options: {
                wide: true
            }
        });
    }
}

export default new FavoriteListCrudOverlayService();
